export default "__VITE_ASSET__3f3aeaf6__"